(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["paisley-search-box"] && !Shopify.designMode) return;
  try {
    class PaisleySearch extends HTMLElement {
    connectedCallback() {
      this.field = this.querySelector('.pps__field');
      this.panel = this.querySelector('.pps__panel');
      this.limit = parseInt(this.dataset.limit, 10) || 6;
      this.timer = null;
      this.controller = null;
      this.cursor = -1;

      this.field.addEventListener('input', this.queue.bind(this));
      this.field.addEventListener('focus', this.queue.bind(this));
      this.field.addEventListener('keydown', this.navigate.bind(this));
      document.addEventListener('click', this.maybeClose.bind(this));
    }

    maybeClose(event) {
      if (!this.contains(event.target)) this.close();
    }

    queue() {
      const term = this.field.value.trim();
      clearTimeout(this.timer);
      if (term.length < 2) {
        this.close();
        return;
      }
      this.timer = setTimeout(() => this.lookup(term), 220);
    }

    navigate(event) {
      const rows = this.panel.querySelectorAll('.pps__row');
      if (event.key === 'Escape') {
        this.close();
        return;
      }
      if (!rows.length) return;
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        const step = event.key === 'ArrowDown' ? 1 : -1;
        this.cursor = (this.cursor + step + rows.length) % rows.length;
        rows.forEach((row, i) => row.setAttribute('aria-selected', i === this.cursor ? 'true' : 'false'));
        rows[this.cursor].scrollIntoView({ block: 'nearest' });
      }
      if (event.key === 'Enter' && this.cursor > -1) {
        event.preventDefault();
        rows[this.cursor].click();
      }
    }

    async lookup(term) {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      const endpoint =
        '/search/suggest.json?q=' +
        encodeURIComponent(term) +
        '&resources[type]=product&resources[limit]=' +
        this.limit +
        '&resources[options][unavailable_products]=last';
      try {
        const response = await fetch(endpoint, { signal: this.controller.signal });
        if (!response.ok) return;
        const payload = await response.json();
        this.paint(payload.resources.results.products || [], term);
      } catch (error) {
        if (error.name !== 'AbortError') this.close();
      }
    }

    paint(products, term) {
      this.cursor = -1;
      if (!products.length) {
        this.panel.innerHTML = '<p class="pps__none">Nothing matched yet — press enter to search everything.</p>';
        this.open();
        return;
      }

      const rows = products
        .map((item) => {
          const src = item.featured_image && item.featured_image.url ? item.featured_image.url : '';
          const thumb = src
            ? '<img class="pps__thumb" src="' + src + '&width=120" alt="" loading="lazy" width="44" height="44">'
            : '<span class="pps__thumb"></span>';
          return (
            '<a class="pps__row" role="option" aria-selected="false" href="' +
            item.url +
            '">' +
            thumb +
            '<span class="pps__meta"><span class="pps__name">' +
            item.title +
            '</span><span class="pps__cost">' +
            (item.price || '') +
            '</span></span></a>'
          );
        })
        .join('');

      this.panel.innerHTML =
        rows +
        '<a class="pps__more" href="/search?q=' +
        encodeURIComponent(term) +
        '&options[prefix]=last">View all results</a>';
      this.open();
    }

    open() {
      this.panel.hidden = false;
      this.field.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.panel.hidden = true;
      this.panel.innerHTML = '';
      this.field.setAttribute('aria-expanded', 'false');
      this.cursor = -1;
    }
  }

  if (!customElements.get('paisley-search')) customElements.define('paisley-search', PaisleySearch);
  } catch(e) { console.error(e); }
})();

})();
